import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentApiService } from '@uc/utilities';
import { CheckboxOption } from '@uc/web/shared/data-models';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class FilterApiService {
	constructor(
		private http: HttpClient,
		private _apiSrv: EnvironmentApiService,
	) {}

	//e.g. Greater London, Wales, South East England
	getLocations(): Observable<CheckboxOption[]> {
		return this.http.get<CheckboxOption[]>(
			this._apiSrv.PHP_URL + 'Universities/regions_get_for_courses.php',
		);
	}
}
